<div class="header">
  <mat-toolbar>
    <button
      *ngIf="!navState.mobileView"
      [title]="navState.opened ? 'close menu' : 'open menu'"
      data-activates="slide-out"
      class="button-collapse menu-normal"
      (click)="closeNav()"
    >
      <i class="material-icons">{{
        navState.opened ? "arrow_back_ios" : "arrow_forward_ios"
      }}</i>
    </button>
    <button
      *ngIf="navState.mobileView"
      [title]="navState.opened ? 'close menu' : 'open menu'"
      data-activates="slide-out"
      class="button-collapse menu-normal"
      (click)="closeNav()"
    >
      <i class="material-icons">menu</i>
    </button>
    <!-- <div class="nav-image">
      <span></span>
    </div> -->
    <img
      *ngIf="navState.mobileView"
      [src]="logoUrl"
      class="logoMobileHeader"
      alt="Subaru Logo"
    />
    <div class="header-content">
      <!--          <fa-icon [icon]="feedbackIcon"></fa-icon>-->
      <!--          <fa-icon [icon]="userIcon"></fa-icon>-->

      <div class="icon">
        <button
          mat-button
          class="eca-icon-only"
          role="img"
          title="Feedback"
          (click)="openFeedback()"
        >
          <mat-icon>flag</mat-icon>
        </button>
      </div>
      <div class="icon">
        <button
          mat-button
          class="eca-icon-only"
          role="img"
          title="User"
          [matMenuTriggerFor]="menu"
        >
          <mat-icon>person</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item>{{ username }}</button>
          <button mat-menu-item (click)="signOut()">Sign Out</button>
        </mat-menu>
      </div>
    </div>
  </mat-toolbar>
</div>
